import * as Yup from 'yup'

export const createForgotPasswordValidationSchema = (t: any) => {
  return Yup.object().shape({
    email: Yup.string()
      .required(t('constant.emailRequired'))
      .email(t('constant.emailInvalid'))
      .matches(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\\.]+$/, t('constant.emailInvalid')),
  })
}
